// extracted by mini-css-extract-plugin
export default {"shipMenu":"ChooseShip_shipMenu__9DlL8","items":"ChooseShip_items__5+x-w","activeShip":"ChooseShip_activeShip__YS9Jf","shipImg":"ChooseShip_shipImg__hqBaW"};